<template>
  <nav class="navbar navbar-expand-lg navbar-light fixed-top" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="#page-top">{{ t('nav.brand') }}</a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fas fa-bars"></i>
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#service">{{ t('nav.service') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#projects">{{ t('nav.projects') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#pricing">{{ t('nav.pricing') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#about">{{ t('nav.about') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#contact">{{ t('nav.contact') }}</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="langDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-globe"></i> {{ t('nav.langLabel') }}
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="langDropdown">
              <a class="dropdown-item" href="#" @click.prevent="setLocale('zh-TW')">{{ t('nav.langZhTW') }}</a>
              <a class="dropdown-item" href="#" @click.prevent="setLocale('en')">{{ t('nav.langEn') }}</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
  import { useI18n } from 'vue-i18n'

  const { t, locale } = useI18n()

  function setLocale(newLocale) {
    locale.value = newLocale
  }
</script>